// Token swap configuration and supported tokens
export interface TokenInfo {
  symbol: string;
  name: string;
  decimals: number;
  icon: string;
  coingeckoId: string | null;
  networks: {
    [key: string]: {
      address: string;
      chainId: number;
    };
  };
}

export const SUPPORTED_TOKENS: Record<string, TokenInfo> = {
  ETH: {
    symbol: 'ETH',
    name: 'Ethereum',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/279/small/ethereum.png',
    coingeckoId: 'ethereum',
    networks: {
      ethereum: {
        address: '0x0000000000000000000000000000000000000000', // Native ETH
        chainId: 1
      },
      hedera: {
        address: '0x...', // Wrapped ETH on Hedera
        chainId: 295 // Hedera mainnet
      }
    }
  },
  LINK: {
    symbol: 'LINK',
    name: 'Chainlink',
    decimals: 18,
    icon: 'https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png',
    coingeckoId: 'chainlink',
    networks: {
      ethereum: {
        address: '0x514910771af9ca656af840dff83e8264ecf986ca',
        chainId: 1
      },
      hedera: {
        address: '0x...', // LINK on Hedera
        chainId: 295
      }
    }
  },
  SOL: {
    symbol: 'SOL',
    name: 'Solana',
    decimals: 9,
    icon: 'https://assets.coingecko.com/coins/images/4128/small/solana.png',
    coingeckoId: 'solana',
    networks: {
      solana: {
        address: 'So11111111111111111111111111111111111111112', // Native SOL
        chainId: 101 // Solana mainnet
      }
    }
  },
  FSPY: {
    symbol: 'FSPY',
    name: 'FoodSply Token',
    decimals: 18,
    icon: '/images/ticker.svg',
    coingeckoId: null, // Will be set after listing
    networks: {
      hedera: {
        address: '0x...', // FSPY token address (to be set after deployment)
        chainId: 295
      }
    }
  }
};

export const SUPPORTED_NETWORKS = {
  ethereum: {
    name: 'Ethereum',
    chainId: 1,
    rpcUrl: 'https://mainnet.infura.io/v3/YOUR_INFURA_KEY',
    blockExplorer: 'https://etherscan.io'
  },
  hedera: {
    name: 'Hedera',
    chainId: 295,
    rpcUrl: 'https://mainnet.hashio.io/api',
    blockExplorer: 'https://hashscan.io'
  },
  solana: {
    name: 'Solana',
    chainId: 101,
    rpcUrl: 'https://api.mainnet-beta.solana.com',
    blockExplorer: 'https://solscan.io'
  }
};

// DEX configurations
export const DEX_CONFIGS = {
  saucerswap: {
    name: 'SaucerSwap',
    network: 'hedera',
    routerAddress: '0x...', // SaucerSwap router address
    factoryAddress: '0x...',
    supportedTokens: ['ETH', 'LINK', 'FSPY']
  },
  uniswap: {
    name: 'Uniswap V3',
    network: 'ethereum',
    routerAddress: '0xE592427A0AEce92De3Edee1F18E0157C05861564',
    factoryAddress: '0x1F98431c8aD98523631AE4a59f267346ea31F984',
    supportedTokens: ['ETH', 'LINK']
  },
  jupiter: {
    name: 'Jupiter',
    network: 'solana',
    apiUrl: 'https://quote-api.jup.ag/v6',
    supportedTokens: ['SOL']
  }
};